import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { Modal, Button } from "react-bootstrap";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Tooltip } from "@mui/material";
import { setEnquiryDb, clearEnquiryState } from "../redux/slices/enquirySlice";
import {
  setNewEnquiryDataDb,
  clearNewEnquiryState,
} from "../redux/slices/setNewEnquiryDataSlice";
import { setShowMessage } from "../redux/slices/notificationSlice";
import moment from "moment";
import { useMemo } from "react";
import { it } from "date-fns/locale";
import State from "./singleComponents/villageCom/state";
import District from "./singleComponents/villageCom/District";
import Taluka from "./singleComponents/villageCom/Taluka";
import Village from "./singleComponents/villageCom/village";
import translations from "../assets/locals/translations";
import {
  clearEditEnquiryState,
  editEnquiryDb,
} from "../redux/slices/editEnquirySlice";
import Axios from "axios";
export default function Enquiry({ workFor, villageId }) {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const customerId = location.state?.customerId;
  const leadEdit = location.state?.leadEdit;
  const enquiryState = useSelector((state) => state.enquiryState.enquiryState);
  const currentLanguage = useSelector((state) => state.language.language);
  const setNewEnquiryDataState = useSelector(
    (state) => state.setNewEnquiryDataState.newEnquiryState
  );
  const editEnquiryState = useSelector(
    (state) => state.editEnquiryState.editEnquiryState
  );

  const [categoriesList, setCategoriesList] = useState([]);
  const [trialArray, setTrialArray] = useState([]);
  const [variant, setVariant] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [editEnquiryDate, setEditEnquiryDate] = useState(null);
  const [editdeliveryDate, setEditDeliveryDate] = useState(null);
  const [seletedOwned, setSelectedOwned] = useState("No");
  const [error, setError] = useState("");
  const [editEnquiryData, setEditEnquiryData] = useState({});
  const [currentCategoryData, setCurrentCategoryData] = useState({
    id: "",
    fields: [],
  });
  const [enquiryData, setEnquiryData] = useState({
    category: "",
    firstName: "",
    lastName: "",
    fatherName: "",
    emailId: "",
    state: "",
    city: "",
    district: "",
    tehsil: "",
    village: "",
    mobileNumber: "",
    brand: "",
    whatsappNumber: "",
    visitReason: "",
    companyName: "",
    sourceOfEnquiry: "",
    modelYear: "",
  });
  const [newEnquiryData, setNewEnquiryData] = useState({
    branchId: "",
    dsp: "",
    firstName: "",
    lastName: "",
    fatherName: "",
    email: "",
    mobileNumber: "",
    whatsappNumber: "",
    state: "",
    district: "",
    tehsil: "",
    block: "",
    village: "",
    ssp: "",
    make: "",
    model: "",
    variant: "",
    oldMaker: " ",
    oldModal: " ",
    condition: " ",
    serialno: "",
    enquiryPrimarySource: "",
    sourceOfEnquiry: "",
    enquiryDate: new Date(),
    deliveryDate: new Date(),
    cuustomerCategory: "",
    modeOfFinance: "",
    bank: "",
    oldTractorOwned: "No",
    category_id: null,
  });

  const generateYears = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
      years.push({ id: years.length + 1, year: year.toString() });
    }
    return years;
  };
  const [newEnquiryList, setNewEnquiryList] = useState({
    listBranch: [],
    listDsp: [],
    listDistrict: [],
    listTehsil: [],
    listBlock: [{ id: "11" }, { id: "22" }, { id: "33" }],
    listVillage: [],
    listSsp: [],
    listMake: [],
    listModel: [],
    listOldModal: [],
    listVariant: [],
    listPrimarySource: [],
    listSourceOfEnquiry: [],
    listCustomerCategory: [],
    listyears: generateYears(1980, 2023),
    listCondition: [
      { id: 1, name: "very Good" },
      { id: 2, name: "Average" },
      { id: 3, name: "Below Average" },
      { id: 4, name: "Good" },
    ],
    listModeOfFinance: [
      { id: 1, name: "Cash" },
      { id: 2, name: "Loan" },
      // { id: 2, name: "Credit Card" },
      // { id: 3, name: "Debit Card" },
    ],
  });
  const [banklist, setBankList] = useState([]);
  function clearStateAndInp() {
    setNewEnquiryData({
      branchId: "",
      dsp: "",
      firstName: "",
      lastName: "",
      fatherName: "",
      email: "",
      mobileNumber: "",
      whatsappNumber: "",
      state: "",
      district: "",
      tehsil: "",
      block: "",
      village: "",
      ssp: "",
      make: "",
      model: "",
      variant: "",
      oldMaker: " ",
      oldModal: " ",
      condition: " ",
      serialno: " ",
      enquiryPrimarySource: "",
      sourceOfEnquiry: "",
      enquiryDate: "",
      deliveryDate: "",
      cuustomerCategory: "",
      modeOfFinance: "",
      bank: "",
      oldTractorOwned: "No",
    });

    const inpClr = document.getElementsByClassName("inpClr");
    Array.from(inpClr).forEach((i) => {
      console.log("inpClr ", i, i.value, i.type);
      if (i.type === "select-one") {
        i.value = 0;
      } else if (i.type === "text") {
        i.value = "";
      }
    });
  }

  function clearState() {
    setCurrentCategoryData({
      id: "",
      fields: [],
    });
    setEnquiryData({
      category: "",
      firstName: "",
      lastName: "",
      fatherName: "",
      state: "",
      city: "",
      district: "",
      tehsil: "",
      village: "",
      mobileNumber: "",
      brand: "",
      whatsappNumber: "",
      visitReason: "",
      sourceOfEnquiry: "",
      companyName: "",
      modelYear: "",
    });
  }
  useEffect(() => {
    if (editEnquiryData && Object.keys(editEnquiryData).length > 0) {
      const editEnquiryDate = new Date(editEnquiryData.date);
      const editDeliveryDate = new Date(editEnquiryData.delivery_date);
      setNewEnquiryData({
        branchId: editEnquiryData.branch_id,
        firstName: editEnquiryData.first_name,
        lastName: editEnquiryData.last_name,
        fatherName: editEnquiryData.middle_name,
        email: editEnquiryData.email,
        mobileNumber: editEnquiryData.phone_number,
        whatsappNumber: editEnquiryData.whatsapp_number,
        state: Number(editEnquiryData.state),
        district: Number(editEnquiryData.district),
        tehsil: Number(editEnquiryData.taluka),
        village: Number(editEnquiryData.village),
        dsp: Number(editEnquiryData.salesperson_id),
        model: `${editEnquiryData.modal_id}`,
        make: `${editEnquiryData.manufacturer}`,
        enquiryDate: editEnquiryDate,
        deliveryDate: editDeliveryDate,
        category_id: editEnquiryData.enquiry_category_id,
        oldMaker: `${editEnquiryData.maker}`,
        variant: editEnquiryData.variantName,
        oldModal: `${editEnquiryData.modalName}`,
        modelYear: editEnquiryData.year_of_manufactur,
        condition: editEnquiryData.condition_of,
        serialno: editEnquiryData.serialno,
        enquiryPrimarySource: `${editEnquiryData.primary_source_id}`,
        sourceOfEnquiry: `${editEnquiryData.enquiry_source_id}`,
        oldTractorOwned: editEnquiryData.old_tractor,
      });
      getDsplist(editEnquiryData.village, editEnquiryData.enquiry_category_id);
      setSelectedOwned(editEnquiryData.old_tractor);
      setEnquiryData({
        category: editEnquiryData.enquiry_category_id,
        firstName: editEnquiryData.first_name,
        lastName: editEnquiryData.last_name,
        fatherName: editEnquiryData.middle_name,
        emailId: editEnquiryData.email,
        mobileNumber: editEnquiryData.phone_number,
        whatsappNumber: editEnquiryData.whatsapp_number,
        state: Number(editEnquiryData.state),
        district: Number(editEnquiryData.district),
        tehsil: Number(editEnquiryData.taluka),
        village: Number(editEnquiryData.village),
        visitReason: editEnquiryData.visitReason,
        companyName: editEnquiryData.company_name,
      });
      getModelList(editEnquiryData.manufacturer);
      getOldModelList(editEnquiryData.maker);
      getSourceOfEnquiryList(editEnquiryData.primary_source_id);
    }
  }, [editEnquiryData]);
  useEffect(() => {
    if (setNewEnquiryDataState.isSuccess) {
      if (setNewEnquiryDataState.data.isSuccess) {
        dispatch(clearNewEnquiryState());
        clearStateAndInp();
        dispatch(setShowMessage("Enquiry is registered"));
        navigate("/sale/enquiries");
      }
    }
  }, [setNewEnquiryDataState]);

  async function getEnquiryCategories() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-enquiry-categories`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          const filteredCategory = response.data.result.filter(
            (item) => item.id !== 1
          );
          setCategoriesList(filteredCategory);
        }
      }
    });
  }
  async function getBranchs() {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/enquiry-data`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          // setCategoriesList(response.data.result)

          const { branches, manufacturers, primary_source, district } =
            response.data.result;
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listBranch"]: branches,
          }));
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listMake"]: manufacturers,
          }));
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listPrimarySource"]: primary_source,
          }));
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listDistrict"]: district,
          }));
        }
      }
    });
  }

  async function getOldModelList(id) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-model/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listOldModal"]: response.data.result,
          }));
        }
      }
    });
  }
  async function getModelList(id) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-model/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listModel"]: response.data.result,
          }));
        }
      }
    });
  }
  async function getSourceOfEnquiryList(id) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-source-enquiry/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listSourceOfEnquiry"]: response.data.result,
          }));
        }
      }
    });
  }
  async function getTehsilList(id) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-tehsil/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listTehsil"]: response.data.result,
          }));
        }
      }
    });
  }
  async function getVillageList(id) {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-village/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listVillage"]: response.data.result,
          }));
        }
      }
    });
  }

  const getVariant = async (id) => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-variant/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          setNewEnquiryList((newEnquiryList) => ({
            ...newEnquiryList,
            ["listVariant"]: response.data.result,
          }));
        }
      }
    });
  };

  // useEffect(() => {
  //   if (workFor === "editEnquiry" && customerId) {
  //     const getEditEnquiryData = async () => {
  //       const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-edit-enquiry-data/${customerId}`;
  //       const config = {
  //         headers: {
  //           token: localStorage.getItem("rbacToken"),
  //         },
  //       };
  //       await axios.get(url, config).then((response) => {
  //         if (response.data) {
  //           console.log(response.data.result, "edtiEnquiry dara");
  //           setEditEnquiryData(response.data.result);
  //         }
  //       });
  //     };
  //     getEditEnquiryData();
  //   }
  // }, [workFor]);

  useEffect(() => {
    if (workFor === "editEnquiry" && customerId) {
      const getEditEnquiryData = async () => {
        const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-edit-enquiry-data/${customerId}`;
        const config = {
          headers: {
            token: localStorage.getItem("rbacToken"),
          },
        };
        try {
          const response = await axios.get(url, config);
          if (response.data && response.data.result) {
            const { result } = response.data;
            const customFieldsString = result.custom_fields;
            const customFields = JSON.parse(customFieldsString);
            result.custom_fields = customFields; // Replace the string with parsed object
            console.log(result, "$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$");
            setEditEnquiryData(result);
          }
        } catch (error) {
          // Handle errors if needed
          console.error("Error fetching data:", error);
        }
      };
      getEditEnquiryData();
    }
  }, [workFor, customerId]);

  const fetchBankList = async () => {
    try {
      const url = `${process.env.REACT_APP_NODE_URL}/api/get-bank-list`;
      const token = localStorage.getItem("rbacToken");
      const config = {
        headers: {
          token: token,
        },
      };

      const response = await Axios.get(url, config);

      if (response.data?.isSuccess) {
        console.log(response.data.result, "response.data.result");
        setBankList(response.data.result);
      } else {
        console.error("API request was not successful");
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };
  useEffect(() => {
    // if (workFor === "newEnquiry") {
    getBranchs();
    fetchBankList();
    // }
    // return;
  }, []);

  useEffect(() => {
    getEnquiryCategories();
  }, []);
  function cancelHandler() {
    navigate("/sale/enquiries");
  }
  const getDsplist = async (village, category) => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-dsp-by-village/${village}/${category}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data.isSuccess) {
        setNewEnquiryList((newEnquiryList) => ({
          ...newEnquiryList,
          ["listDsp"]: response.data.result,
        }));
      }
    });
  };
  useEffect(() => {
    if (enquiryData.village && categoryId) {
      getDsplist(enquiryData.village, categoryId);
    }
  }, [enquiryData.village]);

  const dynamicArea = (fields) => {
    const areaDetail = Object.values(fields).find(
      (item) => item?.main_field_name === "Area Detail"
    );
    const hasState = areaDetail.fields.some(
      (field) => field.field_name === "state"
    );
    const hasDistrict = areaDetail.fields.some(
      (field) => field.field_name === "district"
    );

    if (!hasState) {
      setEnquiryData((prev) => ({
        ...prev,
        state: 2,
      }));
    }
    if (!hasDistrict) {
      setEnquiryData((prev) => ({
        ...prev,
        district: 2,
      }));
    }
  };
  
  async function getFieldCurrentCategories(id) {
    console.log(id, "id##################333");
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-current-fields/${id}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };
    await axios.get(url, config).then((response) => {
      if (response.data) {
        if (response.data.isSuccess) {
          console.log(response.data.result, "fields******************");
          setCurrentCategoryData((currentCategoryData) => ({
            ...currentCategoryData,
            fields: response.data.result,
          }));
          const groupedFieldslists = response.data.result.reduce(
            (acc, field) => {
              const { category_main_field_id, main_field_name } = field;

              // If category is not already added, initialize it
              if (!acc[category_main_field_id]) {
                acc[category_main_field_id] = {
                  main_field_name: main_field_name,
                  fields: [],
                };
              }

              // Push the current field to the respective category
              acc[category_main_field_id].fields.push(field);
              return acc;
            },
            {}
          );
          dynamicArea(groupedFieldslists);
          setTrialArray(groupedFieldslists);
        }
      }
    });
  }

  useEffect(
    (e) => {
      if (categoriesList.length > 0) {
        const firstCategoryId = categoriesList[0].id.toString();
        setSelectedCategory(firstCategoryId);
        if (workFor === "Enquiry") {
          setEnquiryData((enquiryData) => ({
            ...enquiryData,
            category: firstCategoryId,
          }));
        }
      }
    },
    [categoriesList]
  );

  useEffect(() => {
    const idIs = enquiryData.category;

    if (enquiryData.category != 0) {
      setCurrentCategoryData((currentCategoryData) => ({
        ...currentCategoryData,
        id: idIs,
      }));
      setCategoryId(idIs);
      getFieldCurrentCategories(idIs);
    }
  }, [enquiryData.category]);

  useEffect(() => {
    if (enquiryState && enquiryState.result.result === "success") {
      dispatch(setShowMessage("Enquiry Registered Successfully !"));
      dispatch(clearEnquiryState());
      navigate("/sale/enquiries");
    } else if (enquiryState.result.result === "Mobile number already exists") {
      dispatch(
        setShowMessage("*Please use a different mobile number to continue!")
      );
      dispatch(clearEnquiryState());
    }
  }, [enquiryState]);

  useEffect(() => {
    if (editEnquiryState && editEnquiryState.result.result === "success") {
      dispatch(setShowMessage("Enquiry Edited Successfully !"));
      dispatch(clearEditEnquiryState());
      if (leadEdit) {
        navigate("/Leads/leadsboard");
        return;
      }
      navigate("/sale/enquiries");
    }
  }, [editEnquiryState]);

  const handleSubmit = async () => {
    const formatedEnquiryDate = moment(newEnquiryData.enquiryDate).format(
      "YYYY-MM-DD"
    );
    const formatedDeliveryDate = moment(newEnquiryData.deliveryDate).format(
      "YYYY-MM-DD"
    );

    console.log(enquiryData, "Enquiry Data");
    if (workFor === "editEnquiry") {
      const branchId = newEnquiryData.branchId;
      const dsp = newEnquiryData.dsp;
      const model = newEnquiryData.model;
      const make = newEnquiryData.make;
      const oldTractorOwned = newEnquiryData.oldTractorOwned;
      const oldMaker = newEnquiryData.oldMaker;
      const oldModal = newEnquiryData.oldModal;
      const variant = newEnquiryData.variant;
      const condition = newEnquiryData.condition;
      const serialno = newEnquiryData.serialno;
      const enquiryPrimarySource = newEnquiryData.enquiryPrimarySource;
      const sourceOfEnquiry = newEnquiryData.sourceOfEnquiry;
      const modeOfFinance = newEnquiryData.modeOfFinance;
      const bank = newEnquiryData.bank;
      const enquiryDate = formatedEnquiryDate;
      const deliveryDate = formatedDeliveryDate;
      const modelYear = newEnquiryData.modelYear;
      enquiryData.branchId = branchId;
      enquiryData.dsp = dsp;
      enquiryData.model = model;
      enquiryData.make = make;
      enquiryData.enquiryPrimarySource = enquiryPrimarySource;
      enquiryData.sourceOfEnquiry = sourceOfEnquiry;
      enquiryData.modeOfFinance = modeOfFinance;
      enquiryData.bank = bank;
      enquiryData.enquiryDate = enquiryDate;
      enquiryData.deliveryDate = deliveryDate;
      enquiryData.oldTractorOwned = oldTractorOwned;
      enquiryData.oldMaker = oldMaker;
      enquiryData.oldModal = oldModal;
      enquiryData.variant = variant;
      enquiryData.condition = condition;
      enquiryData.serialno = serialno;
      enquiryData.modelYear = modelYear;
      if (!enquiryData.customFields) {
        enquiryData.customFields = {};
      }
      console.log(enquiryData, "newEnquiry");
      if (customerId) {
        enquiryData.customerId = customerId;
        dispatch(editEnquiryDb(enquiryData));
      }
    } else {
      const branchId = await localStorage.getItem("currentDealerId");
      const dsp = newEnquiryData.dsp;
      const model = newEnquiryData.model;
      const make = newEnquiryData.make;
      const oldMaker = newEnquiryData.oldMaker;
      const oldModal = newEnquiryData.oldModal;
      const variant = newEnquiryData.variant;
      const condition = newEnquiryData.condition;
      const serialno = newEnquiryData.serialno;
      const enquiryPrimarySource = newEnquiryData.enquiryPrimarySource;
      const sourceOfEnquiry = newEnquiryData.sourceOfEnquiry;
      const modeOfFinance = newEnquiryData.modeOfFinance;
      const bank = newEnquiryData.bank;
      const oldTractorOwned = newEnquiryData.oldTractorOwned;
      const enquiryDate = formatedEnquiryDate;
      const deliveryDate = formatedDeliveryDate;
      enquiryData.branchId = branchId;
      enquiryData.dsp = dsp;
      enquiryData.model = model;
      enquiryData.make = make;
      enquiryData.enquiryPrimarySource = enquiryPrimarySource;
      enquiryData.sourceOfEnquiry = sourceOfEnquiry;
      enquiryData.modeOfFinance = modeOfFinance;
      enquiryData.bank = bank;
      enquiryData.oldTractorOwned = oldTractorOwned;
      enquiryData.enquiryDate = enquiryDate;
      enquiryData.deliveryDate = deliveryDate;
      enquiryData.oldMaker = oldMaker;
      enquiryData.oldModal = oldModal;
      enquiryData.variant = variant;
      enquiryData.condition = condition;
      enquiryData.serialno = serialno;
      if (!enquiryData.customFields) {
        enquiryData.customFields = {};
      }
      console.log(
        enquiryData,
        "enquiryDataenquiryDataenquiryDataenquiryDataenquiryDataenquiryDataenquiryData"
      );
      dispatch(setEnquiryDb(enquiryData));
    }
  };
  const isPhoneNumberExist = async () => {
    const url = `${process.env.REACT_APP_NODE_URL}/api/enquiry/get-enquiry-mobile-number-exist/${enquiryData.mobileNumber}/${enquiryData.category}`;
    const config = {
      headers: {
        token: localStorage.getItem("rbacToken"),
      },
    };

    const response = await axios.get(url, config);
    if (response.data && response.data.result === true) {
      dispatch(setShowMessage("* Mobile Number Already Exist !"));
    }
  };

  const onFocusOut = () => {
    console.log(enquiryData, "enquirutrt");
    isPhoneNumberExist();
  };
  const handleCustomFieldChange = (fieldName, value) => {
    setEnquiryData((prevData) => ({
      ...prevData,
      customFields: {
        ...prevData.customFields,
        [fieldName]: value,
      },
    }));
  };

  let commonFieldsRendered = false;
  function getSelectedFields(data) {
    const { field, field_type } = data;
    switch (field) {
      case "branchId":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Select Branch *
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="myInput inpClr"
              name="branchId"
              defaultValue={newEnquiryData.branchId}
            >
              <option value="0" className="myLabel">
                select
              </option>
              {newEnquiryList.listBranch &&
                newEnquiryList.listBranch.length > 0 &&
                newEnquiryList.listBranch.map((i, index) => {
                  return (
                    <option
                      selected={i.id == newEnquiryData.branchId ? true : false}
                      key={index}
                      value={i.id}
                      className="myLabel"
                    >
                      {i.name}
                    </option>
                  );
                })}
            </select>
          </section>
        );
        break;
      case "dsp":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Select DSP *
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="myInput inpClr"
              name="dsp"
              defaultValue={newEnquiryData.dsp}
            >
              <option value="0" className="myLabel">
                select
              </option>
              {newEnquiryList.listDsp &&
                newEnquiryList.listDsp.length > 0 &&
                newEnquiryList.listDsp.map((i, index) => {
                  return (
                    <option
                      selected={
                        newEnquiryData.dsp && newEnquiryData.dsp ? true : false
                      }
                      key={index}
                      value={i.userId}
                      className="myLabel"
                    >{`${i.sale_person}`}</option>
                  );
                })}
            </select>
          </section>
        );
        break;
      case "firstName":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel">First name*</label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              autoComplete="false"
              type="text"
              name="firstName"
              defaultValue={enquiryData.firstName}
            />
          </section>
        );
        break;
      case "lastName":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel">Last name*</label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              autoComplete="false"
              type="text"
              name="lastName"
              defaultValue={enquiryData.lastName}
            />
          </section>
        );
        break;
      case "fatherName":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel">Father name*</label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              autoComplete="false"
              type="text"
              name="fatherName"
              defaultValue={enquiryData.fatherName}
            />
          </section>
        );
        break;
      case "email":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel">Email*</label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              autoComplete="false"
              type="text"
              name="emailId"
              defaultValue={enquiryData.emailId}
            />
          </section>
        );
        break;

      case "state":
        return (
          <State
            onSelectedState={onSelectedStatedata}
            stateId={enquiryData.state}
          />
        );
        break;
      case "district":
        return (
          <District
            onSelectedDistrict={onSelectedDistrictdata}
            stateId={enquiryData.state}
            districtId={enquiryData.district}
          />
        );
        break;
      case "taluko":
        return (
          <Taluka
            onSelectedTaluka={onSelectedTalukadata}
            districtId={enquiryData.district}
            talukaId={enquiryData.tehsil}
          />
        );
        break;
      case "village":
        return (
          <Village
            onSelectedVillage={onSelectedVillagedata}
            talukaId={enquiryData.tehsil}
            villageId={enquiryData.village}
          />
        );
        break;
      case "make":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Select Make *
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="inpClr myInput"
              name="make"
              value={newEnquiryData.make}
            >
              <option value="0" className="myLabel">
                select New Make
              </option>
              {newEnquiryList.listMake &&
                newEnquiryList.listMake.length > 0 &&
                newEnquiryList.listMake.map((i, index) => {
                  return (
                    <option
                      key={index}
                      value={i.id}
                      className="myLabel"
                    >
                      {i.name}
                    </option>
                  );
                })}
            </select>
          </section>
        );
        break;
      case "primarySource":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Enquiry Primary Source *
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="inpClr myInput"
              name="enquiryPrimarySource"
              defaultValue={newEnquiryData.enquiryPrimarySource}
            >
              <option value="0" className="myLabel">
                select
              </option>
              {newEnquiryList.listPrimarySource &&
                newEnquiryList.listPrimarySource.length > 0 &&
                newEnquiryList.listPrimarySource.map((i, index) => {
                  return (
                    <option
                      selected={
                        i.id == newEnquiryData.enquiryPrimarySource
                          ? true
                          : false
                      }
                      key={index}
                      value={i.id}
                      className="myLabel"
                    >
                      {i.name}
                    </option>
                  );
                })}
            </select>
          </section>
        );
        break;
      case "sourceOfEnquiry":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Select Source Of Enquiry *
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="inpClr myInput"
              name="sourceOfEnquiry"
              defaultValue={newEnquiryData.sourceOfEnquiry}
            >
              <option value="0" className="myLabel">
                select
              </option>
              {newEnquiryList.listSourceOfEnquiry &&
                newEnquiryList.listSourceOfEnquiry.length > 0 &&
                newEnquiryList.listSourceOfEnquiry.map((i, index) => {
                  return (
                    <option key={index} value={i.id} className="myLabel">
                      {i.name}
                    </option>
                  );
                })}
            </select>
          </section>
        );
        break;

      case "mobileNumber":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Mobile number
            </label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              onBlur={onFocusOut}
              autoComplete="false"
              type="text"
              name="mobileNumber"
              maxLength={15}
              defaultValue={enquiryData.mobileNumber}
            />
          </section>
        );

        break;
      case "whatsappNumber":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Whatsapp number
            </label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              autoComplete="false"
              type="text"
              maxLength={15}
              name="whatsappNumber"
              defaultValue={enquiryData.whatsappNumber}
            />
          </section>
        );
        break;
      case "oldTractor":
        return (
          <section className="d-flex mt-3 flex-column  ">
            <label className="ms-1 myLabel" htmlFor="email">
              Old Tractor Owned{" "}
            </label>
            <div className="d-flex">
              <input
                defaultChecked={seletedOwned === "Yes" ? true : false}
                value="Yes"
                onChange={changeHandler}
                type="radio"
                id="html"
                name="oldTractorOwned"
              />
              <label className="ms-1 myLabel" htmlFor="email">
                Yes
              </label>

              <input
                defaultChecked={seletedOwned === "No" ? true : false}
                value="No"
                onChange={changeHandler}
                className="ms-3"
                type="radio"
                id="css"
                name="oldTractorOwned"
              />
              <label className="ms-1 myLabel" htmlFor="email">
                No
              </label>
            </div>
            {seletedOwned === "Yes" && (
              <>
                <p className="mt-3 mb-0"> Select Details* </p>
                <div className=" row  m-0">
                  <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
                    <select
                      onChange={changeHandlerNewEnquiry}
                      className="inpClr myInput"
                      name="oldMaker"
                      value={newEnquiryData.oldMaker}
                    >
                      <option value="0" className="myLabel">
                        Select Old Maker
                      </option>
                      {newEnquiryList.listMake &&
                        newEnquiryList.listMake.length > 0 &&
                        newEnquiryList.listMake.map((i, index) => {
                          return (
                            <option
                              key={index}
                              value={i.id}
                              className="myLabel"
                            >
                              {i.name}
                            </option>
                          );
                        })}
                    </select>
                  </section>
                  <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
                    <select
                      onChange={changeHandlerNewEnquiry}
                      className="inpClr myInput"
                      name="oldModal"
                      value={newEnquiryData.oldModal}
                    >
                      <option value="0" className="myLabel">
                        Select Old Modal
                      </option>
                      {newEnquiryList.listOldModal &&
                        newEnquiryList.listOldModal.length > 0 &&
                        newEnquiryList.listOldModal.map((i, index) => {
                          return (
                            <option
                              key={index}
                              value={i.id}
                              className="myLabel"
                            >
                              {i.modalName}
                            </option>
                          );
                        })}
                    </select>
                  </section>

                  {/* <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
                    <select
                      onChange={changeHandlerNewEnquiry}
                      className="inpClr myInput"
                      name="variant"
                      defaultValue={newEnquiryData.variant}
                    >
                      <option value="0" className="myLabel">
                        Select Old Variant
                      </option>
                      {newEnquiryList.listVariant &&
                        newEnquiryList.listVariant.length > 0 &&
                        newEnquiryList.listVariant.map((i, index) => {
                          return (
                            <option
                              key={index}
                              value={i.id}
                              className="myLabel"
                            >
                              {i.variantName}
                            </option>
                          );
                        })}
                    </select>
                  </section> */}
                </div>
                <div className=" row mt-3 m-0">
                  <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
                    <select
                      onChange={changeHandler}
                      className="inpClr myInput"
                      name="modelYear"
                      defaultValue={newEnquiryData.modelYear}
                    >
                      <option value="0" className="myLabel">
                        Manufactur Year
                      </option>
                      {newEnquiryList.listyears &&
                        newEnquiryList.listyears.length > 0 &&
                        newEnquiryList.listyears.map((i, index) => {
                          return (
                            <option
                              key={index}
                              value={i.year}
                              className="myLabel"
                            >
                              {i.year}
                            </option>
                          );
                        })}
                    </select>
                  </section>

                  <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
                    <select
                      onChange={changeHandlerNewEnquiry}
                      className="inpClr myInput"
                      name="condition"
                      defaultValue={newEnquiryData.condition}
                    >
                      <option value="0" className="myLabel">
                        Select Condition
                      </option>
                      {newEnquiryList.listCondition &&
                        newEnquiryList.listCondition.length > 0 &&
                        newEnquiryList.listCondition.map((i, index) => {
                          return (
                            <option
                              key={index}
                              value={i.name}
                              className="myLabel"
                            >
                              {i.name}
                            </option>
                          );
                        })}
                    </select>
                  </section>
                  <section className="d-flex mt-2 flex-column col-12 col-sm-6 col-lg-4">
                    <input
                      onChange={changeHandlerNewEnquiry}
                      className="myInput inputElement"
                      autoComplete="false"
                      type="text"
                      name="serialno"
                      defaultValue={newEnquiryData.serialno}
                      placeholder="Serial no."
                    />
                  </section>
                </div>
              </>
            )}
          </section>
        );

        break;
      case "modal":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Select Model *
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="inpClr myInput"
              name="model"
              value={newEnquiryData.model}
            >
              <option value="0" className="myLabel">
                select New Modal
              </option>
              {newEnquiryList.listModel &&
                newEnquiryList.listModel.length > 0 &&
                newEnquiryList.listModel.map((i, index) => {
                  return (
                    <option key={index} value={i.id} className="myLabel">
                      {i.modalName}
                    </option>
                  );
                })}
            </select>
          </section>
        );
        break;
      case "enquiryDate":
        return (
          <section className="datePicker d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              EnquiryDate *
            </label>
            <DatePicker
              selected={newEnquiryData.enquiryDate}
              dateFormat="dd/MM/yyyy"
              onChange={(date) =>
                setNewEnquiryData((newEnquiryData) => ({
                  ...newEnquiryData,
                  ["enquiryDate"]: date,
                }))
              }
            />
          </section>
        );
        break;
      case "deliveryDate":
        return (
          <section className="datePicker d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Expected Delivery Date
            </label>
            <DatePicker
              selected={newEnquiryData.deliveryDate}
              dateFormat="dd/MM/yyyy"
              onChange={(date) =>
                setNewEnquiryData((newEnquiryData) => ({
                  ...newEnquiryData,
                  ["deliveryDate"]: date,
                }))
              }
            />
          </section>
        );
        break;
      case "modeOfFinance":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Select Mode Of Finance{" "}
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="inpClr myInput"
              name="modeOfFinance"
            >
              <option value="0" className="myLabel">
                select
              </option>
              {newEnquiryList.listModeOfFinance &&
                newEnquiryList.listModeOfFinance.length > 0 &&
                newEnquiryList.listModeOfFinance.map((i, index) => {
                  return (
                    <option key={index} value={i.name} className="myLabel">
                      {i.name}
                    </option>
                  );
                })}
            </select>
          </section>
        );
        break;
      case "bank":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel" htmlFor="email">
              Select Bank{" "}
            </label>
            <select
              onChange={changeHandlerNewEnquiry}
              className="inpClr myInput"
              name="bank"
            >
              <option value="0" className="myLabel">
                select
              </option>
              {banklist &&
                banklist.length > 0 &&
                banklist.map((i, index) => {
                  return (
                    <option key={index} value={i.bankname} className="myLabel">
                      {i.bankname}
                    </option>
                  );
                })}
            </select>
          </section>
        );
        break;
      case "visitReason":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel">Visit Reason</label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              autoComplete="false"
              type="text"
              name="visitReason"
              defaultValue={enquiryData.visitReason}
            />
          </section>
        );
        break;
      case "companyName":
        return (
          <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
            <label className="myLabel">Comapany Name</label>
            <input
              onChange={changeHandler}
              className="myInput inputElement"
              autoComplete="false"
              type="text"
              name="companyName"
              defaultValue={enquiryData.companyName}
            />
          </section>
        );
      default:
        switch (field_type) {
          case 1:
            return (
              <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
                <label className="myLabel">{data.name}*</label>
                <input
                  onChange={(e) =>
                    handleCustomFieldChange(data.field, e.target.value)
                  }
                  className="myInput inputElement"
                  autoComplete="false"
                  type="text"
                  name={data.field}
                  defaultValue={
                    editEnquiryData.custom_fields &&
                    editEnquiryData.custom_fields[data.field]
                      ? editEnquiryData.custom_fields[data.field]
                      : ""
                  }
                />
              </section>
            );
        }
    }
  }

  function changeHandlerNewEnquiry(e) {
    const name = e.target.name;
    const value = e.target.value;
    setNewEnquiryData((newEnquiryData) => ({
      ...newEnquiryData,
      [name]: value,
    }));

    if (value === "" || value === 0) {
    } else {
      // setNewEnquiryData(newEnquiryData => ({ ...newEnquiryData, [name]: value }))
      switch (name) {
        // case "village":
        //   getDsplist(value);
        //   break;
        // case "branchId":
        //   getDspList(value);
        //   break;
        case "oldMaker":
          getOldModelList(value);
          break;
        case "make":
          getModelList(value);
          break;
        case "oldModal":
          getVariant(value);
          break;
        case "enquiryPrimarySource":
          getSourceOfEnquiryList(value);
          break;
        case "district":
          getTehsilList(value);
          break;
        case "tehsil":
          getVillageList(value);
          break;
      }
    }
  }
  function changeHandler(e) {
    const name = e.target.name;
    const value = e.target.value;

    setEnquiryData((enquiryData) => ({ ...enquiryData, [name]: value }));
    if (name === "oldTractorOwned") {
      setNewEnquiryData((prevState) => ({
        ...prevState,
        oldTractorOwned: value,
      }));
      setSelectedOwned(value);
    }
  }

  const onSelectedStatedata = (val) => {
    setEnquiryData((pre) => {
      return { ...pre, state: val };
    });
  };
  const onSelectedDistrictdata = (val) => {
    setEnquiryData((pre) => {
      return { ...pre, district: val };
    });
  };
  const onSelectedTalukadata = (val) => {
    setEnquiryData((pre) => {
      return { ...pre, tehsil: val };
    });
  };
  const onSelectedVillagedata = (val) => {
    setEnquiryData((pre) => {
      return { ...pre, village: val };
    });
  };
  const redirectModal = () => {
    navigate(-1);
  };
  // ------dynamic form code-----
  // const [formState, setFormState] = useState({});

  // const handleChange = (id, value) => {
  //   setFormState((prevState) => ({
  //     ...prevState,
  //     [id]: value,
  //   }));
  // };

  // const renderFields = (fields) => {
  //   return fields.map((field) => {
  //     return (

  //       <section className="d-flex mt-3 flex-column col-12 col-sm-6 col-lg-4">
  //         <label className="myLabel">{field.name}</label>
  //         <input
  //           type="text"
  //           value={formState[field.id] || ''}
  //           onChange={(e) => handleChange(field.id, e.target.value)}
  //           className="myInput inputElement"
  //           autoComplete="false"
  //         />
  //         {field.children && renderFields(field.children)}
  //       </section>
  //     );
  //   });
  // };

  // const groupedFields = currentCategoryData.fields.reduce((acc, field) => {

  //   const section = field.main_field_name || 'Other';
  //   if (!acc[section]) acc[section] = [];
  //   if (field.resource_id) {
  //     const parent = acc[section].find((parentField) => parentField.id === field.resource_id);
  //     if (parent) {
  //       if (!parent.children) parent.children = [];
  //       parent.children.push(field);
  //     }
  //   } else {
  //     acc[section].push(field);
  //   }
  //   return acc;
  // }, {});
  return (
    <main className="bg-white p-3 rounded">
      <div className=" row m-0">
        <div className="col-6">
          <h5 className="m-0">
            {workFor === "Enquiry" ? "Enquiry" : "Edit Enquiry"}
          </h5>
        </div>
        <div className="col-6 d-flex align-items-end justify-content-end">
          <Button
            variant="btn btn-warning mx-1"
            style={{
              width: "70px",
              height: "35px",
              fontSize: "14px",
              borderRadius: "20px",
            }}
            onClick={() => {
              redirectModal();
            }}
          >
            BACK
          </Button>
        </div>

        {workFor === "Enquiry" && (
          <>
            <div className="row mt-3 m-0">
              <section className="d-flex mt-3 flex-column col-12 col-lg-5">
                <label className="myLabel" htmlFor="email">
                  Select category *
                </label>
                <select
                  onChange={changeHandler}
                  className="myInput"
                  name="category"
                >
                  {categoriesList.length > 0 &&
                    categoriesList.map((item, index) => {
                      return (
                        <option
                          selected={item.id == 2 ? true : false}
                          value={item.id}
                          key={index}
                          className="myLabel"
                        >
                          {item.category_name}
                        </option>
                      );
                    })}
                </select>
              </section>
            </div>

            {enquiryData.category != "" && currentCategoryData.id != "" && (
              <>
                <div className="row mt-2 m-0">
                  {/* {currentCategoryData.fields.length > 0 ? (
                    <>
                      {currentCategoryData.fields.map((i) => {
                        return getSelectedFields(i);
                      })}
                    </>
                  ) : (
                    <h6>There is no selected fields</h6>
                  )} */}
                  {Object.keys(trialArray).map((categoryId) => (
                    <section key={categoryId} className=" mt-3">
                      <div className="row">
                        <h3>{trialArray[categoryId].main_field_name}</h3>
                      </div>

                      <div className="row">
                        {trialArray[categoryId].fields.map((field) => {
                          return getSelectedFields(field);
                        })}
                      </div>
                    </section>
                  ))}

                  {currentCategoryData.fields.length > 0 && (
                    <section className="d-flex pt-3 flex-column flex-sm-row">
                      <button
                        className="col-12 col-sm-5 col-lg-2 myBtn py-2"
                        onClick={handleSubmit}
                        type="button"
                      >
                        Submit{" "}
                      </button>
                    </section>
                  )}
                </div>
              </>
            )}
          </>
        )}

        {workFor === "editEnquiry" && (
          <>
            <div className="row mt-3 m-0">
              <section className="d-flex mt-3 flex-column col-12 col-lg-5">
                <label className="myLabel" htmlFor="email">
                  Select category *
                </label>
                <select
                  onChange={changeHandler}
                  className="myInput"
                  name="category"
                  defaultValue={newEnquiryData.category_id}
                >
                  {categoriesList.length > 0 &&
                    categoriesList.map((item, index) => {
                      return (
                        <option
                          selected={
                            item.id == newEnquiryData.category_id ? true : false
                          }
                          value={item.id}
                          key={index}
                          className="myLabel"
                        >
                          {item.category_name}
                        </option>
                      );
                    })}
                </select>
              </section>
            </div>

            {enquiryData.category != "" && currentCategoryData.id != "" && (
              <>
                <div className="row mt-2 m-0">
                  {/* {currentCategoryData.fields.length > 0 ? (
                    <>
                      {currentCategoryData.fields.map((i) => {
                        return getSelectedFields(i);
                      })}
                    </>
                  ) : (
                    <h6>There is no selected fields</h6>
                  )} */}
                  {Object.keys(trialArray).map((categoryId) => (
                    <section key={categoryId} className=" mt-3">
                      <div className="row">
                        <h3>{trialArray[categoryId].main_field_name}</h3>
                      </div>

                      <div className="row">
                        {trialArray[categoryId].fields.map((field) => {
                          return getSelectedFields(field);
                        })}
                      </div>
                    </section>
                  ))}
                  {currentCategoryData.fields.length > 0 && (
                    <section className="d-flex pt-3 flex-column flex-sm-row">
                      <button
                        className="col-12 col-sm-5 col-lg-2 myBtn py-2"
                        onClick={handleSubmit}
                        type="button"
                      >
                        Submit{" "}
                      </button>
                    </section>
                  )}
                </div>
              </>
            )}
          </>
        )}
      </div>
      {/* <div className="mt-5">
        <h1>Dynamic form</h1>
        <form>
          {Object.keys(groupedFields).map((section) => (
            <div key={section} className="mt-5 mb-5">
              <h3>{section}</h3>
              <div className="row">
                {renderFields(groupedFields[section])}
              </div>
            </div>
          ))}
          <button type="submit">Submit</button>
        </form>
      </div> */}
    </main>
  );
}
